// extracted by mini-css-extract-plugin
export default {"root":"SellLocations-root","LocationsList":"SellLocations-LocationsList"};